<script lang="ts">
export default {
  name: 'KkAccountImageWithIcon',
}
</script>
<script setup lang="ts">
import { computed } from 'vue'

import iconInstagramPath from '../../../../../../images/sns/icon_instagram.svg'
import iconFacebookPath from '../../../../../../images/sns/icon_facebook.svg'
import iconTwitterPath from '../../../../../../images/sns/icon_x.svg'
interface Props {
  imageUrl: string
  snsType: string
}
const props = withDefaults(defineProps<Props>(), {
  imageUrl: '',
  snsType: ''
})

const snsImage = computed((): string => {
  switch (props.snsType) {
  case 'facebook':
    return iconFacebookPath
  case 'instagram':
    return iconInstagramPath
  case 'twitter':
    return iconTwitterPath
  default:
    return ''
  }
})
</script>
<template>
  <div class="accountImage">
    <img alt="" :src="props.imageUrl" class="accountImage__thumbnail">
    <img alt="" :src="snsImage" class="accountImage__icon">
  </div>
</template>
<style lang="scss" scoped>
.accountImage {
  position: relative;
  margin-right: 12px;
  img{
    border-radius: 50%;
  }
  &__thumbnail {
    width: 36px;
    height: 36px;
    object-fit: cover;
  }
  &__icon {
    position: absolute;
    width: 18px;
    height: 18px;
    bottom: 0;
    left: 60%;
    bottom: 10%;
    background: #fff;
    border: solid 1px #fff;
  }
}
</style>
